export const SUB_ACCOUNT_FAQ_ID = 'add-sub-without-account';
export const SUB_ACCOUNT_FAQ_HREF = `/faq#${SUB_ACCOUNT_FAQ_ID}`;
export const SUB_REPORT_FAQ_ID = 'report-a-sub';
export const SUB_REPORT_FAQ_HREF = `/faq#${SUB_REPORT_FAQ_ID}`;
